
























import { Component, Vue } from "vue-property-decorator";
import LogoRow from "@/components/LogoRow.vue";
import AppFooter from "@/components/AppFooter.vue";
import AuthRegisterForm from "@/components/AuthRegisterForm.vue";

@Component({
  components: { LogoRow, AppFooter, AuthRegisterForm }
})
export default class AuthRegister extends Vue {
  get lang() {
    return this.$store.state.lang.data;
  }
}
